import React, { useState } from "react";

const timetableData = [
  {
    date: "2025-10-07",
    day: "Monday",
    sessions: [
      { time: "7:00 PM - 8:00 PM", topic: "Group Discussion Practice", level: "Intermediate" },
      { time: "8:15 PM - 9:15 PM", topic: "Vocabulary Building", level: "Beginner" },
      { time: "7:00 PM - 8:00 PM", topic: "Group Discussion Practice", level: "Intermediate" },
      { time: "8:15 PM - 9:15 PM", topic: "Vocabulary Building", level: "Beginner" },
      { time: "7:00 PM - 8:00 PM", topic: "Group Discussion Practice", level: "Intermediate" },
      { time: "8:15 PM - 9:15 PM", topic: "Vocabulary Building", level: "Beginner" },
    ],
  },
  {
    date: "2025-10-09",
    day: "Wednesday",
    sessions: [
      { time: "7:00 PM - 8:00 PM", topic: "Pronunciation Workshop", level: "All Levels" },
      { time: "8:15 PM - 9:15 PM", topic: "Mock Interview Session", level: "Advanced" },
    ],
  },
  {
    date: "2025-10-11",
    day: "Friday",
    sessions: [
      { time: "7:00 PM - 8:00 PM", topic: "Storytelling Session", level: "Intermediate" },
      { time: "8:15 PM - 9:15 PM", topic: "Spoken English Games", level: "Beginner" },
      { time: "7:00 PM - 8:00 PM", topic: "Group Discussion Practice", level: "Intermediate" },
      { time: "8:15 PM - 9:15 PM", topic: "Vocabulary Building", level: "Beginner" },
    ],
  },
];

const TimeTable = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleDay = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div style={styles.pageContainer}>
      <h2 style={styles.heading}>Weekly Time Table</h2>
      <p style={styles.subHeading}>
        Click on a date to see the sessions for that day.
      </p>

      <div style={styles.listContainer}>
        {timetableData.map((dayItem, index) => (
          <div key={index} style={styles.dayCard}>
            <div
              style={styles.dayHeader}
              onClick={() => toggleDay(index)}
            >
              <span>{dayItem.date} - {dayItem.day}</span>
              <span style={styles.arrow}>{openIndex === index ? "▲" : "▼"}</span>
            </div>

            {openIndex === index && (
              <div style={styles.sessionList}>
                {dayItem.sessions.map((session, i) => (
                  <div key={i} style={styles.sessionItem}>
                    <div>
                      <div style={styles.time}>{session.time}</div>
                      <div style={styles.topic}>{session.topic}</div>
                    </div>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <span style={styles.levelTag}>{session.level}</span>
                      <button style={styles.registerBtn}>Register</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

// Styles
const styles = {
  pageContainer: {
    padding: "40px 20px",
    maxWidth: "700px",
    margin: "0 auto",
    background: "#f9fcff",
    minHeight: "100vh",
  },
  heading: {
    textAlign: "center",
    fontSize: "2rem",
    color: "#007BFF",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  subHeading: {
    textAlign: "center",
    color: "#555",
    marginBottom: "30px",
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  dayCard: {
    background: "#fff",
    borderRadius: "15px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    overflow: "hidden",
  },
  dayHeader: {
    padding: "15px 20px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    fontWeight: "bold",
    fontSize: "1rem",
    color: "#007BFF",
  },
  arrow: {
    fontSize: "0.9rem",
  },
  sessionList: {
    padding: "10px 20px",
    borderTop: "1px solid #f0f0f0",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  sessionItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 0",
    borderBottom: "1px solid #f0f0f0",
  },
  time: {
    fontWeight: "bold",
    color: "#333",
  },
  topic: {
    color: "#555",
    fontSize: "0.95rem",
  },
  levelTag: {
    backgroundColor: "#e7f2ff",
    color: "#007BFF",
    padding: "4px 10px",
    borderRadius: "15px",
    fontSize: "0.8rem",
    fontWeight: "500",
  },
  registerBtn: {
    backgroundColor: "#007BFF",
    color: "#fff",
    border: "none",
    padding: "6px 12px",
    borderRadius: "15px",
    cursor: "pointer",
    fontSize: "0.85rem",
    fontWeight: "500",
  },
};

export default TimeTable;
